import { render, staticRenderFns } from "./IndustryNorms.vue?vue&type=template&id=3b0488d2&"
import script from "./IndustryNorms.vue?vue&type=script&lang=js&"
export * from "./IndustryNorms.vue?vue&type=script&lang=js&"
import style0 from "./IndustryNorms.vue?vue&type=style&index=0&id=3b0488d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports